import axios from 'axios';
import { ApiException } from 'src/api/FiretrolApiClient';

/**
 * Extracts an HTTP status code from the shapes the app actually throws:
 * NSwag `ApiException` (`.status`), Axios errors (`response?.status`), or
 * anything else (undefined — treated as a non-HTTP failure, e.g. a network
 * error or a cancellation).
 */
export function getStatusCode(err: unknown): number | undefined {
  if (err != null && ApiException.isApiException(err)) {
    return err.status;
  }
  if (axios.isAxiosError(err)) {
    return err.response?.status;
  }
  return undefined;
}
